// Excel експортът на „Разделени маси".
//
// Редовете идват ФИЛТРИРАНИ и ПОДРЕДЕНИ от таблицата (`onFilteredRowsChange`),
// не суровият отговор — файлът повтаря екрана. Числата остават ЧИСЛА.
//
// Колоните са същите като досега; накрая се добавя коментарът към
// разделянето, който на екрана стои в изгасена по подразбиране колона.

import dayjs from "dayjs";

import { exportToExcel, type ExcelColumn } from "../../../../utils/excelExport";
import type { SplitRow } from "./billsSplitsMath";

type Options = {
  rows: SplitRow[];
  t: (key: string, options?: Record<string, unknown>) => string;
};

/** „04.09.2026 18:42" — същият формат като в досегашния износ. */
const formatMoment = (value: string | null): string => {
  const moment = dayjs(value);
  return value && moment.isValid() ? moment.format("DD.MM.YYYY HH:mm") : "";
};

export const exportBillsSplits = ({ rows, t }: Options) => {
  const columns: ExcelColumn<SplitRow>[] = [
    {
      header: t("reportsPage.date"),
      value: (row) => formatMoment(row.split_date),
      width: 18,
    },
    {
      header: t("reportsPage.fromTable"),
      value: (row) => row.from_bill_name,
      width: 14,
    },
    {
      header: t("reportsPage.toTable"),
      value: (row) => row.to_bill_name,
      width: 14,
    },
    {
      header: t("reportsPage.waiter"),
      value: (row) => row.waiterLabel,
      width: 22,
    },
    {
      header: t("reportsPage.products"),
      value: (row) => row.itemsCount,
      width: 12,
    },
    {
      header: t("reportsPage.amount"),
      value: (row) => Number(row.amount.toFixed(2)),
      width: 14,
    },
    {
      header: t("reportsPage.billsSplitsComment"),
      value: (row) => row.comment ?? "",
      width: 28,
    },
  ];

  exportToExcel<SplitRow>({
    filename: t("reportsPage.billsSplitsTitle"),
    sheetName: t("reportsPage.billsSplits"),
    columns,
    rows,
  });
};
